import React, { useEffect } from 'react';
import classnames from 'classnames';
import styles from './styles/AnimatedCheckScreen.module.scss';

interface IProps {
  onFinish: () => void;
  className?: string;
  timer?: number;
}

const AnimatedCheckScreen: React.FC<IProps> = ({
  className,
  onFinish,
  timer = 2000,
}) => {
  useEffect(() => {
    const timeoutId = setTimeout(onFinish, timer);

    // Cleanup function to clear the timeout if the component unmounts before the timeout finishes
    return () => clearTimeout(timeoutId);
  }, [onFinish, timer]);

  return (
    <div className={classnames(styles.container, className)}>
      <img
        src="https://quashed.co.nz/images/user/upload-complete.gif"
        alt="Upload Complete"
        loading="lazy"
      />
    </div>
  );
};

export default AnimatedCheckScreen;
